import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { createSieveSizeCaptionGetter, createSieveSizeGetter } from 'Data/ViewModels/Equipment/ISieveSize';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../../../../Lib/Object/deepEquals';
import { Field, TextOutput } from '../../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../../Layout';
import { getLabelForPortionState } from '../../../../Helpers';

let SeparationDetailsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const separatingSieveSizeId = useSelector(createWorksheetSelector!('Separation.SeparatingSieveSizeId'));

  const separatingSieveSize = useSelector(
    pipe(
      createWorksheetSelector!('data.Equipment.AllSieveSizes', false),
      createSieveSizeGetter(separatingSieveSizeId),
      (s) => s?.Size
    ),
    deepEquals
  );

  const separatingSieveSizeCaption = useSelector(
    pipe(
      createWorksheetSelector!('data.Equipment.AllSieveSizes', false),
      createSieveSizeCaptionGetter(separatingSieveSizeId),
      valueOrDefault('N/A')
    )
  );

  const stateBeforeSeparation: StateOfMaterial = useSelector(
    createWorksheetSelector!(`Masses.StateAfterMassDetermination`)
  );

  return (
    <ListFieldSection>
      <NamePrefixModifier appendNamePrefix="Separation">
        <Field input={<TextOutput />} label="Separating Sieve Size" value={separatingSieveSizeCaption} />
        <Field
          input={<WorksheetEquipmentDropdown />}
          name="SeparatingSieve"
          label="Separating Sieve"
          equipmentType="sieve"
          queryParams={{ SieveSize: `${separatingSieveSize?.value} ${separatingSieveSize?.uom}` }}
        />
      </NamePrefixModifier>

      <Field
        input={<TextOutput />}
        label="State of Material Prior to Separation"
        value={getLabelForPortionState(stateBeforeSeparation)}
      />
    </ListFieldSection>
  );
};

SeparationDetailsSection = withInjectedProps(SeparationDetailsSection);

export { SeparationDetailsSection };
export default SeparationDetailsSection;
